function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { extractFragmentHashFromPrefix, removePrefixFromCompositionName } from "../../queryUtils/prefixes";
import { buildQueryAndVariablesHash } from "../../queryUtils/queryAndVariablesHashing";
function buildSubQueryVariables(subQueryVariableNames, variablesPassedToRootQuery) {
    const subQueryVariables = Array.from(subQueryVariableNames).reduce((acc, cur)=>{
        // Avoid including variables that were not passed to the useRootQuery call
        // However, we still want to include them even if they are specified
        // as `undefined`.
        if (!(cur in variablesPassedToRootQuery)) {
            return acc;
        }
        const originalValue = variablesPassedToRootQuery[cur];
        return _object_spread_props(_object_spread({}, acc), {
            [removePrefixFromCompositionName(cur)]: originalValue
        });
    }, {});
    return subQueryVariables;
}
export default function calculateSubQueryRuntimeValues(subQueryGraphQlDocuments, options, observableStore) {
    const rootVariablesValues = options.variables;
    return Object.entries(subQueryGraphQlDocuments).map(([prefix, { subQuery, variableNames }])=>{
        const variables = buildSubQueryVariables(variableNames, rootVariablesValues);
        const skip = options.skip[prefix];
        const observableFragment = skip ? null : observableStore.createObservableFragment({
            document: subQuery,
            variables
        });
        const subQueryWithMetadata = {
            subQuery,
            variables,
            skip,
            fragmentHash: extractFragmentHashFromPrefix(prefix),
            prefix,
            observableFragment,
            documentHashWithVariables: buildQueryAndVariablesHash(subQuery, variables).documentHashWithVariables
        };
        return subQueryWithMetadata;
    });
}

//# sourceMappingURL=calculateSubQueryRuntimeValues.js.map